export default {
  appName: "Brainbox Admin",
  loginRedirect: "user"
}
